<template>
  <div class="content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Content"
}
</script>

<style scoped>
.content {
  padding: 16px;
  background: var(--gray-white);
  /* background: linear-gradient(to bottom, #d8edfe, #f1f1f1 200px, #f1f1f1 20px, #f1f1f1); */
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/Content.vue